<template>
<svg width="48" height="8" viewBox="0 0 48 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="8" rx="4" fill="#D6DBE1"/>
</svg>

</template>
<script lang="ts" setup>

</script>
